import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GPlanInput } from 'src/app/_models/gplan-input';
import { LaPlanningResults } from 'src/app/_models/laResults';
import { TopologyList, TopologyWithRoot } from 'src/app/_models/topology-list';
import { ApplicationsResultsService } from 'src/app/_services/applications-results-service/applications-results.service';
import { CommunicationService } from 'src/app/_services/communication-service/communication.service';
import { GPlanService } from 'src/app/_services/gplan-service/gplan.service';

@Component({
  selector: 'app-la-planning',
  templateUrl: './la-planning.component.html',
  styleUrls: ['./la-planning.component.css']
})
export class LaPlanningComponent implements OnInit {

  @ViewChild('searchInput', { static: false }) searchInputRef!: ElementRef;
  private shouldFocusInput = false;

  constructor(
    private applicationsResultsService: ApplicationsResultsService,
    public translate: TranslateService,
    private communicationService: CommunicationService,
    private gplanService: GPlanService
  ) { 
    const lant = localStorage.getItem('Language');
    this.translate.use(lant);
  }

  public isSidebarOpen: boolean;
  public topologies: TopologyList;
  public selectTopologyMap: Map<string, string> = new Map<string, string>();
  laPlanningResults: Array<LaPlanningResults> = new Array<LaPlanningResults>();
  public selectedTopology: string;

  isSearching: boolean[] = Array(6).fill(false);
  searchText: string[] = Array(6).fill('');

  ngOnInit() {
    this.topologies = JSON.parse(localStorage.getItem("topologies"));
    this.loadTopologies();
    console.log('Topology Map:', this.selectTopologyMap);
    this.applicationsResultsService.setSidebarOpen(true);
    this.isSidebarOpen = this.applicationsResultsService.getSidebarOpen();

    this.loadLaPlanningResults(this.getTopologiesDisplayNameForSelectField()[0]);
    // this.getListOfScenariosForSelectedTopology(selecte/);
  }

  loadLaPlanningResults(topologyId: string) {

    this.applicationsResultsService.getLaPlanningResults(this.selectTopologyMap.get(topologyId) || topologyId).subscribe((data) => {

    this.getListOfScenariosForSelectedTopology(this.selectTopologyMap.get(topologyId) || topologyId).subscribe((scenariosMap: Map<number, string>) => {
        
      this.laPlanningResults = (data || []).filter(item => item).map(item => new LaPlanningResults(
        item.gridElement_id || "N/A",
        item.dso_internal_id || "N/A",
        item.type  || "N/A",
        item.maxLoad  || "N/A",
        item.numberOfViolations  || "N/A",
        item.scenarioId ? item.scenarioId + " - " + scenariosMap.get(item.scenarioId) || "N/A" : "N/A",
        item.maxLoadTimestamp || "N/A",
        item.maxCurrent || "N/A",
        item.maxApparentPower || "N/A"
      ));
    })

      console.log('LA Planning Results:', this.laPlanningResults);
    });
  }
  
  /**
   * This function retrieves the list of scenarios for a given topology ID
   * It returns an Observable that emits a Map of scenario IDs and their names
   */
  getListOfScenariosForSelectedTopology(topologyId: string): Observable<Map<number, string>> {
    return this.gplanService.getListAvailableScenariosForOverallResults(topologyId).pipe(
      map((data: Array<GPlanInput>) => {
        const scenariosMap = new Map<number, string>();
        data.forEach((scenario: GPlanInput) => {
          scenariosMap.set(scenario.id, scenario.name);
        });
        return scenariosMap;
      })
    );
  }

  getTopologiesDisplayNameForSelectField(): string[] {
    return Array.from(this.selectTopologyMap.keys());
  }

  sortTable(columnIndex: number): void {
    const table = document.getElementById("sortableTable");
    if (!table) return;
  
    const rows = Array.from((table as HTMLTableElement).rows).slice(1); // Skip header
    let isAscending = table.getAttribute("data-sort-order") === "asc";
  
    const parseDateToTimestamp = (value: string): number => {
      const trimmed = value.trim();
      const date = new Date(trimmed);
      return isNaN(date.getTime()) ? Infinity : date.getTime();
    };
  
    const sampleSize = Math.min(5, rows.length);
    const isDate = rows.slice(0, sampleSize).some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      if (
        value === '' ||
        value.toLowerCase() === 'n/a' ||
        !/[\/\-:,]/.test(value)
      ) {
        return false;
      }
      const date = new Date(value);
      return !isNaN(date.getTime());
    });
    const isNumeric = rows.some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      return !isNaN(parseFloat(value)) && value !== '' && value !== 'N/A' && value !== 'n/a';
    });
  
    rows.sort((rowA, rowB) => {
      const cellA = rowA.cells[columnIndex].innerText.trim() || '';
      const cellB = rowB.cells[columnIndex].innerText.trim() || '';

      if (isDate) {
        const dateA = parseDateToTimestamp(cellA);
        const dateB = parseDateToTimestamp(cellB);
        // console.log("Date sorting");
        return isAscending ? dateA - dateB : dateB - dateA;
      }

      
      if (isNumeric) {
        const numbA = (cellA === 'N/A' || cellA === '' || isNaN(parseFloat(cellA))) ? Infinity : parseFloat(cellA);
        const numbB = (cellB === 'N/A' || cellB === '' || isNaN(parseFloat(cellB))) ? Infinity : parseFloat(cellB);
  
        // console.error("Numeric sorting");
        return isAscending ? numbA - numbB : numbB - numbA;
      } 
  
      return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
    });
    table.setAttribute("data-sort-order", isAscending ? "desc" : "asc");
    rows.forEach(row => table.appendChild(row));
  }

  toggleSearch(index: number): void {
    // Мне нужнно сделать так, чтобы при нажатии на кнопку поиска, она меняла свое состояния 
    // при этому все остальные кнопки поиска меняли свое состояние на false
    // И каждый раз при нажатии все searchText[index] менялись на пустую строку
    // this.isSearching.forEach((_, i))
    this.isSearching = this.isSearching.map((_, i) => i === index ? !this.isSearching[i] : false);

    if(this.isSearching.every(value => value === false)){
      this.searchText = Array(6).fill('');
    }
    console.log("Search Toggled:", this.isSearching);

    if(this.isSearching[index]){
      this.shouldFocusInput = true;
    }
  }

  ngAfterViewChecked(){
    if(this.shouldFocusInput && this.searchInputRef){
      this.searchInputRef.nativeElement.focus();
      this.shouldFocusInput = false;
    }
  }

  filteredLaPlanningResults(): any[] {
    
    if(this.isSearching.every(value => value === false)){
      this.searchText = Array(8).fill('');
    }
    if(this.searchText.every(text => !text)){
      return this.laPlanningResults;
    }

    return this.laPlanningResults.filter(item => {
      return this.searchText.every((text, index) => {
        if(!text) return true;
        const value = Object.values(item)[index];
        return value.toString().toLowerCase().includes(text.toLowerCase())
      })
    })
  }
  
  loadTopologies(){
    this.topologies.topologiesWithRoots.forEach((TopologyWithRoot: TopologyWithRoot) => {
      this.selectTopologyMap.set(TopologyWithRoot.displayName || TopologyWithRoot.internalDsoId + " - "  + TopologyWithRoot.TopologyId, TopologyWithRoot.TopologyId );
    });

    this.selectTopologyMap.forEach((value, key) => {
      if (key === this.topologies.topologiesWithRoots[0].displayName || key === this.topologies.topologiesWithRoots[0].internalDsoId + " - "  + this.topologies.topologiesWithRoots[0].TopologyId) {
        this.selectedTopology = key;
      }
    });

    console.log("Selected Topology: ", this.selectedTopology);
  }

  resetDefaultTopology(){
    this.communicationService.setTopologyId(null);
  }

    getViolationColoring(laPlanningResult: LaPlanningResults): string{
      if(laPlanningResult.numberOfViolations > 0){
        return 'red';
      }
    }

}
